import { AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { EntityMaster } from '../shared/models/entityMaster.model';
import { Constants } from '../shared/constants';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { EntitySearch } from '../shared/models/requestModels/entitySearch.model';
import { stringify } from 'querystring';
import { DatePipe } from '@angular/common';
//import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatAccordion } from '@angular/material/expansion';
import { MatTableDataSource } from '@angular/material/table';
export class FilterValues {
  key: string;
  value: string
}

@Component({
  selector: 'app-entity-search',
  templateUrl: './entity-search.component.html',
  styleUrls: ['./entity-search.component.scss']
,  standalone: false
})


export class EntitySearchComponent implements OnInit, AfterViewInit {

  getEntity: string = environment.baseUrl+'EntityMaster/GetEntities';
  getEntityByID : string =  environment.baseUrl+ "EntityMaster/GetEntityById";
  getEntityFields : string =  environment.baseUrl+ "EntityMaster/GetFieldByEntity"; ;

  faDatePicker = faCalendarAlt;

  exportDisabled : boolean = false;
  selectedEntity: string;
  filterValues: FilterValues[];
  displayedColumns: string[] = [];
  isFilterPresent: boolean = true;
  form: FormGroup;
  constant: Constants = new Constants();
  entities: any;
  entityFields: any;
  entityNameLabel: string;
  filter: {};
  private paginator: MatPaginator;
  private sort: MatSort;
  @ViewChild('TABLE', { static: false }) table: ElementRef;
  @ViewChild(MatAccordion, { static: false }) accordion: MatAccordion;
  @ViewChildren('input') components: QueryList<'input'>
  constructor(private baseHttpService: BaseHttpService, private fb: FormBuilder,private datePipe: DatePipe) { }
  dataSource = new MatTableDataSource();
  // @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  // @ViewChild(MatSort, { static: false }) sort: MatSort;
  searchForm = new FormGroup({
    entityControl: new FormControl(new EntityMaster()),
    search: new FormControl(''),
    dynamicControls: this.fb.group({})
  });
  @ViewChild(MatSort, { static: false} ) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator, { static: false }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      // this.applyFilter('');
     // this.getEntityData(this.selectedEntity);
    } 
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  async ngOnInit() {
    await this.getEntities();
  }

  ngAfterViewInit() {
    // setTimeout(() =>this.dataSource.paginator = this.paginator);
    // setTimeout(() =>this.dataSource.sort = this.sort);
  }

  async getEntities() {
    
    this.baseHttpService.get(this.getEntity).subscribe(   
      async (result) => {
        
        if (result != null && result.length > 0) {
          this.entityNameLabel = "Entity";
          this.entities = result;
          this.selectedEntity = this.entities[0].entityID;
          this.searchForm.controls['entityControl'].setValue(this.entities[0].entityID);
          this.getEntityData(this.selectedEntity);
        }
        else {
          this.entityNameLabel = "No Entity Present";
        }
      }

    );
  }

  getFilters(entity: string) {
    this.baseHttpService.getById(this.getEntityFields, entity).
      subscribe(
        async (result) => {
          this.entityFields = [];
          if (result != null && result.length > 0) {
            this.entityFields = result.filter(x => x.isSearchable == true);

            if (this.entityFields.length > 0) {
              this.isFilterPresent = true;
            } else {
              this.isFilterPresent = false;
            }
          }
          else {
            this.isFilterPresent = false;
          }
        });
  }

  filterOpen(event) {
    this.getFilters(this.selectedEntity);

  }

  entityChange(event) {
    this.selectedEntity = event.value;
    this.getFilters(this.selectedEntity);
    this.getEntityData(this.selectedEntity);
  }

  getEntityData(entityId) {
    this.dataSource = new MatTableDataSource([]);
    let entitySearch = new EntitySearch();
    entitySearch.entityID = entityId;
    this.baseHttpService.post(this.getEntityByID, entitySearch).
      subscribe(
        async (result) => {
          this.displayedColumns = result.entityFields.filter(x => x.isDisplay == true).map(s => s.entityFieldName);
          if (result.elementData.length) {
            this.exportDisabled = false;
            this.dataSource = new MatTableDataSource(result.elementData);
          } else {
            this.exportDisabled = true;
            this.dataSource = new MatTableDataSource([]);
            
          }
        })

  }

  async resetFilters(event) {
    this.filterValues = [];
    if (this.entityFields) { 
      await this.entityFields.forEach(element => {
       let a = (<HTMLFormElement>document.getElementById(element.questionMasters.questionId)).value = "";
      });
  }
  this.searchForm.controls["search"].setValue('');
  this.getEntityData(this.selectedEntity);
}

  async applyFilters(event) {
    this.filterValues = [];
    if (this.entityFields) {
      await this.entityFields.forEach(element => {
        let filterValue = new FilterValues();
        let elementValue = (<HTMLInputElement>document.getElementById(element.questionMasters.questionId));
        
        if (elementValue.value != null && elementValue.value.toLowerCase().trim().length > 0) {
          filterValue.key = element.questionMasters.questionId;
          filterValue.value = elementValue.name == 'dateField' ? this.datePipe.transform(elementValue.value, 'yyyy-MM-dd'): elementValue.value;
          this.filterValues.push(filterValue);
        }

      });
      let entitySearch = {
        entityId: this.selectedEntity,
        filters: this.filterValues
      }

      this.baseHttpService.post(this.getEntityByID, entitySearch).
        subscribe(
          async (result) => {
            if (result.elementData.length) {
              this.exportDisabled = false;
              this.dataSource = new MatTableDataSource(result.elementData);
            } else {
              this.exportDisabled = true;
              this.dataSource = new MatTableDataSource([]);
            }
          })

    }
  }

  ExportTOExcel()
 {
//   const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);
//   const wb: XLSX.WorkBook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
//   /* save to file */
//   XLSX.writeFile(wb, 'Dashboard.xlsx');
  
}
}
